// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

export const getCustomerAddress_AllOrder = (query: any): any =>
  axios.get(`${baseUrl}/api/maps/reverse-geocode${query}`)

export const getAddressAutoComplete_AllOrder = (query: any): any =>
  axios.get(`${baseUrl}/api/maps/autocomplete?${query}`)
